// SEO optimization utilities

export const generateStructuredData = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "ContaX",
    "description": "Transform every networking opportunity into lasting professional relationships. ContaX helps you remember, organize, and nurture the connections that matter most.",
    "url": "https://mycontax.com",
    "category": "Professional Networking",
    "operatingSystem": "Web",
    "applicationCategory": "BusinessApplication",
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "USD",
      "description": "Free forever"
    },
    "provider": {
      "@type": "Organization",
      "name": "ContaX",
      "url": "https://mycontax.com"
    },
    "downloadUrl": "https://mycontax.com",
    "screenshot": "https://mycontax.com/logo-contex.png",
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "12847"
    }
  };

  return JSON.stringify(structuredData);
};

export const updateMetaTags = (title: string, description: string, url?: string) => {
  // Update page title
  document.title = title;

  // Update meta description
  const metaDescription = document.querySelector('meta[name="description"]');
  if (metaDescription) {
    metaDescription.setAttribute('content', description);
  }

  // Update Open Graph tags
  const ogTitle = document.querySelector('meta[property="og:title"]');
  if (ogTitle) {
    ogTitle.setAttribute('content', title);
  }

  const ogDescription = document.querySelector('meta[property="og:description"]');
  if (ogDescription) {
    ogDescription.setAttribute('content', description);
  }

  if (url) {
    const ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) {
      ogUrl.setAttribute('content', url);
    }
  }

  // Update Twitter Card tags
  const twitterTitle = document.querySelector('meta[name="twitter:title"]');
  if (twitterTitle) {
    twitterTitle.setAttribute('content', title);
  }

  const twitterDescription = document.querySelector('meta[name="twitter:description"]');
  if (twitterDescription) {
    twitterDescription.setAttribute('content', description);
  }
};

export const generateSitemap = () => {
  const baseUrl = 'https://mycontax.com';
  const pages = [
    { url: '/', priority: 1.0, changefreq: 'weekly' },
    { url: '/privacy', priority: 0.7, changefreq: 'monthly' },
    { url: '/terms', priority: 0.7, changefreq: 'monthly' },
    { url: '/unsubscribe', priority: 0.3, changefreq: 'yearly' }
  ];

  const sitemap = `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
${pages.map(page => `  <url>
    <loc>${baseUrl}${page.url}</loc>
    <lastmod>${new Date().toISOString().split('T')[0]}</lastmod>
    <changefreq>${page.changefreq}</changefreq>
    <priority>${page.priority}</priority>
  </url>`).join('\n')}
</urlset>`;

  return sitemap;
};

export const generateRobotsTxt = () => {
  return `User-agent: *
Allow: /
Disallow: /unsubscribe
Disallow: /api/

Sitemap: https://mycontax.com/sitemap.xml`;
};

export const preloadCriticalResources = () => {
  // Preload important images
  const logo = new Image();
  logo.src = '/logo-contex.png';

  // Preload critical fonts (if using custom fonts)
  const fontLink = document.createElement('link');
  fontLink.rel = 'preconnect';
  fontLink.href = 'https://fonts.googleapis.com';
  document.head.appendChild(fontLink);

  const fontApiLink = document.createElement('link');
  fontApiLink.rel = 'preconnect';
  fontApiLink.href = 'https://fonts.gstatic.com';
  fontApiLink.crossOrigin = 'anonymous';
  document.head.appendChild(fontApiLink);
};

export const addStructuredDataToPage = () => {
  // Remove existing structured data
  const existingScript = document.querySelector('script[type="application/ld+json"]');
  if (existingScript) {
    existingScript.remove();
  }

  // Add new structured data
  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.textContent = generateStructuredData();
  document.head.appendChild(script);
};

export const optimizeImages = () => {
  // Add loading="lazy" to images below the fold
  const images = document.querySelectorAll('img');
  images.forEach((img, index) => {
    if (index > 2) { // Skip first few images (above the fold)
      img.setAttribute('loading', 'lazy');
    }
  });
};

export const addCanonicalUrl = (url: string) => {
  const existingCanonical = document.querySelector('link[rel="canonical"]');
  if (existingCanonical) {
    existingCanonical.setAttribute('href', url);
  } else {
    const canonical = document.createElement('link');
    canonical.rel = 'canonical';
    canonical.href = url;
    document.head.appendChild(canonical);
  }
};